import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { useTranslation } from '@/contexts/TranslationContext';

interface Profile {
  user_id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
}

interface NewChatDialogProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  users: Profile[];
  onUserSelect: (userId: string) => void;
}

const NewChatDialog: React.FC<NewChatDialogProps> = ({
  searchQuery,
  onSearchChange,
  users,
  onUserSelect
}) => {
  const { t } = useTranslation();
  const filteredUsers = users.filter(user => 
    user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.display_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Search className="w-4 h-4 text-muted-foreground" />
        <Input
          placeholder={t('messages.searchUsers')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="bg-white/5 border-white/20"
        />
      </div>
      
      <div className="space-y-2 max-h-[400px] overflow-y-auto">
        {filteredUsers.map((user) => (
          <div
            key={user.user_id}
            className="flex items-center justify-between p-3 rounded-lg glass border border-white/10 hover:bg-white/5 cursor-pointer"
            onClick={() => onUserSelect(user.user_id)}
          >
            <div className="flex items-center space-x-3">
              <Avatar className="h-10 w-10">
                <AvatarImage src={user.avatar_url || ''} />
                <AvatarFallback className="bg-primary text-primary-foreground">
                  {user.display_name?.[0] || user.username?.[0] || '?'}
                </AvatarFallback>
              </Avatar>
              <div>
                <p className="font-medium text-sm">
                  {user.display_name || user.username}
                </p>
                <p className="text-xs text-muted-foreground">
                  @{user.username}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewChatDialog;